import BaseDialog from "../../modelDialogs/BaseDialog";
import { itx } from "../../translationItx/itx";
import { saveProject } from "../SaveProject";

export default function AskIfSnapshotShouldBeSavedDialog(props: {}) {
  return (
    <BaseDialog
      title={itx("AskIfSnapshotShouldBeSaved.saveOldVersion", "Ältere Datei speichern?")}
      okCaption={itx("ok", "Ok")}
      onClose={() => {
        return true;
      }}
      onOk={() => {
        const p = state.projectMetadata.id.indexOf("-snapshot");
        if (p > 0) {
          // first ask if an older version should be saved
          state.projectMetadata.id = state.projectMetadata.id.substring(0, p);
        }
        saveProject();
        return true;
      }}
      hideXButton={true}
    >
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {itx("AskIfSnapshotShouldBeSaved.question", "Soll wirklich diese Version des Projektes gespeichert werden? ")}
        <br />
        <br />
        {itx("AskIfSnapshotShouldBeSaved.olderVersionOpen", " Hier ist eine ältere Version geöffnet.")}
        <br />
        <br />
        {itx("AskIfSnapshotShouldBeSaved.loosingNewerData", "Es können einige Vortschritte verloren gehen.")}
      </div>
    </BaseDialog>
  );
}
